import type { Blueprint } from '../../base/blueprints/Blueprint';
import { instanceOfBlueprint } from '../../base/blueprints/Blueprint';
import type { AlwaysChoice } from '../enums/AlwaysChoice';
import type { NeverChoice } from '../enums/NeverChoice';
import type { InternallyChoice } from '../enums/InternallyChoice';
import type { WhenChoice } from '../enums/WhenChoice';

export interface VisibleBlueprint extends Blueprint
{
    visible: AlwaysChoice | NeverChoice | InternallyChoice | WhenChoice;
    visibleWhen: string;
}

export const instanceOfVisibleBlueprint = (object: any): object is VisibleBlueprint =>
{
    return instanceOfBlueprint(object) && 'visible' in object;
};
